import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Circle, Text } from 'react-konva';
import PropTypes from 'prop-types';
import React from 'react';
import annTools from './commonAnnotationTools';
import Annotation from './annotation';
const Info = props => {
  const draggable = props.draggable,
    scale = props.scale,
    pageHeight = props.pageHeight,
    offset = props.offset,
    dpiScale = props.dpiScale,
    selectedID = props.selectedID,
    annotation = props.annotation,
    onDragEnd = props.onDragEnd;
  const colorString = annotation.colorString,
    id = annotation.id;

  // only care about the first one
  const _annTools$adaptPDFRec = annTools.adaptPDFRects(scale, pageHeight, annotation, offset),
    _annTools$adaptPDFRec2 = _slicedToArray(_annTools$adaptPDFRec, 1),
    box = _annTools$adaptPDFRec2[0];
  const color = annTools.parseColor(colorString);
  const colorRGBAString = "rgba(".concat(color[0], ",").concat(color[1], ",").concat(color[2], ",0.6)");

  // Base dimensions that will be scaled
  const baseFontSize = 20;
  const baseCircleDiameter = 30;
  const baseStrokeWidth = 3.5;
  const baseSelectionBoxSize = 30;

  // Scale the dimensions based on the zoom factor and DPI scale
  const fontSize = baseFontSize * scale / dpiScale;
  const circleDiameter = baseCircleDiameter * scale / dpiScale;
  const strokeWidth = baseStrokeWidth * scale / dpiScale;
  const selectionBoxSize = baseSelectionBoxSize * scale / dpiScale;

  // Calculate offsets to center the circle within the selection box
  const circleOffset = (selectionBoxSize - circleDiameter) / 2;
  const adjustedX = box.x / dpiScale + circleOffset;
  const adjustedY = box.y / dpiScale + circleOffset;

  // Center the circle within the selection box
  const circleAdjustedX = adjustedX + circleDiameter / 2;
  const circleAdjustedY = adjustedY + circleDiameter / 2;
  const circleRadius = 0.5 * (circleDiameter - strokeWidth);
  return /*#__PURE__*/React.createElement(Annotation, {
    draggable: draggable,
    box: {
      x: box.x,
      y: box.y,
      w: selectionBoxSize,
      h: selectionBoxSize
    },
    selectedID: selectedID,
    annotationID: id,
    dpiScale: dpiScale,
    scale: scale,
    onDragEnd: onDragEnd
  }, /*#__PURE__*/React.createElement(Circle, {
    key: "".concat(id, "-circle"),
    x: circleAdjustedX,
    y: circleAdjustedY,
    radius: circleRadius,
    stroke: colorRGBAString,
    strokeWidth: strokeWidth
  }), /*#__PURE__*/React.createElement(Text, {
    key: "".concat(id, "-text"),
    x: circleAdjustedX - circleDiameter / 2,
    y: circleAdjustedY - circleDiameter / 2 + 1 * scale / dpiScale,
    width: circleDiameter,
    height: circleDiameter,
    fontFamily: "Georgia",
    fontSize: fontSize,
    fontStyle: "bold",
    fill: colorRGBAString,
    align: "center",
    verticalAlign: "middle",
    text: "i"
  }));
};
Info.propTypes = {
  annotation: PropTypes.shape({
    colorString: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  dpiScale: PropTypes.number.isRequired,
  draggable: PropTypes.bool.isRequired,
  offset: PropTypes.shape({
    x: PropTypes.number,
    y: PropTypes.number
  }).isRequired,
  onDragEnd: PropTypes.func.isRequired,
  pageHeight: PropTypes.number.isRequired,
  scale: PropTypes.number.isRequired,
  selectedID: PropTypes.string.isRequired
};
export default Info;